import { connect } from "react-redux";
import ContactDetailsView from "./ContactDetailsView.jsx";

import {
  fetchContactShareAnanlytics,
  fetchAssetAnalytics,
  viewContact,
  fetchContact,
  fetchShareSection,
} from "src/legacy/redux/actions/rolodex.jsx";

const mapStateToProps = (state, ownProps) => {
  const shares = state.legacyRootReducer.rolodex.contact.shares;

  return {
    contacts: state.legacyRootReducer.rolodex.items,
    contact: state.legacyRootReducer.rolodex.contact.item,
    loadingContact: state.legacyRootReducer.rolodex.contact.loading,
    shares: shares.items,
    loadingShares: shares.loading,
    loading: shares.loading || state.legacyRootReducer.rolodex.loading,
    currentPage: (shares.pagination && shares.pagination.current) || 0,
    totalPages: (shares.pagination && shares.pagination.totalPages) || 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchContactShareAnanlytics: (id, page) => {
      dispatch(fetchContactShareAnanlytics(id, page));
    },

    fetchAssetAnalytics: (contactID, shareID, sectionID, assetID) => {
      return dispatch(
        fetchAssetAnalytics(contactID, shareID, sectionID, assetID)
      );
    },

    viewContact: (id) => {
      return dispatch(viewContact(id));
    },

    fetchContact: (id) => {
      return dispatch(fetchContact(id));
    },

    fetchShareSection: (contactId, shareId, sectionId) => {
      return dispatch(fetchShareSection(contactId, shareId, sectionId));
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    viewContact: (id) => {
      var contacts = stateProps.contacts;

      if (contacts) {
        var found =
          contacts.find((item) => {
            return item.id == id;
          }) != null;

        if (found) {
          return dispatchProps.viewContact(id);
        } else {
          return dispatchProps.fetchContact(id);
        }
      }
    },
  });
};

const ContactDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContactDetailsView);

export default ContactDetailsContainer;
